module.exports = __webpack_public_path__ + "img/per-corporatie.76dcfe41.svg";